<div class="flex flex-center flex-between" style="margin-right: 30px">
  <app-page-title></app-page-title>
  <med-btn skin="red" class="med-btn red" [disabled]="!basket.basketHasItems()" (click)="basket.clear()">
    Очистити корзину
  </med-btn>
</div>

<div class="flex flex-between">
  <div class="table-wrapper" style="margin-bottom: 108px; width: calc(100% - 528px)">

    <p-table
      styleClass="p-datatable-sm"
      [scrollable]="true"
      scrollHeight="flex"
      [value]="basket.allItems()"
      [customSort]="true"
      [lazy]="true"
      [resizableColumns]="true"
      columnResizeMode="expand"
      [columns]="tabHeader"
      [reorderableColumns]="true"
      (onColReorder)="saveColumnOrder()">
      <ng-template pTemplate="header">
        <tr>
          <th class="table-header-text table-header-bg-grey" *ngFor="let column of tabHeader" pReorderableColumn pResizableColumn>
            <div style="display: inline-block" class="flex align-items-center">
                {{ column.label }}&nbsp;
            </div>
        </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-row let-columns="columns">
        <tr class="table-content-text">
          <ng-container *ngFor="let col of columns">
          <td class="h10-text black-80" *ngIf="col.key === 'mnnId'">
            <span>{{row.good.mnnId}}</span>
          </td>
          <td class="h10-text black-80" *ngIf="col.key === 'mnnName'">
            <span>{{row.good.mnnName}}</span>
          </td>
          <td class="h10-text black-80" *ngIf="col.key === 'dosage'">
            <div class="flex-12rem">
                        <span class="truncate-text" [pTooltip]="tooltipDosage">
                          {{row.good.dosage}}
                        </span>
              <ng-template #tooltipDosage>
                <div class="flex items-center h10-text">
                  {{row.good.dosage}}
                </div>
              </ng-template>
            </div>
          </td>
          <td class="h10-text black-60" *ngIf="col.key === 'tradeName'">
            <div class="flex-12rem">
                        <span class="truncate-text" [pTooltip]="tooltipTradeName">
                          {{row.good.tradeName}}
                        </span>
              <ng-template #tooltipTradeName>
                <div class="flex items-center h10-text">
                  {{row.good.tradeName}}
                </div>
              </ng-template>
            </div>
          </td>

          <td class="h10-text black-80" *ngIf="col.key === 'series'">
            <span>{{row.seriesCatalogue}}</span>
          </td>
          <td class="h10-text black-80" *ngIf="col.key === 'distributedQuantity'">
            <span>
              {{getDistributedQuantityForBase(row)}}
            </span>
          </td>
          <td size="16" *ngIf="col.key === 'action'">
            <med-icon-delete (click)="basket.delete(row)"></med-icon-delete>
          </td>
        </ng-container>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div style=" margin-left: 20px; margin-right: 30px; margin-top: 15px; width: 100%">
    <med-card>
      <div style="padding: 24px">
        <div class="grid">
          <div class="col-2">
            <med-icon-aimbulance
              size="48"
              mode="circle"
            ></med-icon-aimbulance>
          </div>

          <div class="col-8 p-grid justify-content-center align-content-center">
                          <span class="white-space-nowrap postavka">
                              Дані для розподілу
                          </span>
          </div>
        </div>
        <div style="margin-top: 24px; padding: 16px">
          <div class="flex flex-between">
            <div class="h10-text black-60">
              Кількість позицій
            </div>
            <div class="h10-text black-80">
              10
            </div>
          </div>
          <div class="flex flex-between" style="margin-top: 16px">
            <div class="h10-text black-60">
              Кількість одиниць товару
            </div>
            <div class="h10-text black-80">
              21 500
            </div>
          </div>
          <div class="flex flex-between" style="margin-top: 16px">
            <div class="h10-text black-60">
              Заклад-відправник
            </div>
            <div class="h10-text black-80">
              Львівська лікарня №1
            </div>
          </div>
          <div class="flex flex-between" style="margin-top: 24px; width: 100%">
            <med-btn (click)="goToSubDistribution()" [disabled]="!basket.basketHasItems() || loading">
              <med-icon-sync
                *ngIf="loading"
                size="20"
                class="animate--rotate mr-2"
              ></med-icon-sync>
              Почати дочірній розподіл
              &nbsp;
              <med-icon-arrow-right size="18"></med-icon-arrow-right>
            </med-btn>
          </div>
        </div>
      </div>
    </med-card>
  </div>
</div>
